import PropTypes from 'prop-types';
import React from 'react';
import styles from '../Dropdown.less';
import Select from '@wix/site-react-dropdown/dist/src/containers/Select/Select';

const FIELD_FILL_PARAM = 'wixseating-field-fill';
const FIELD_FONT_PARAM = 'wixseating-field-font';
const FIELD_TEXT_PARAM = 'wixseating-field-txt';
const FIELD_BORDER_SIZE_PARAM = 'wixseating-field-border-size';

export default class extends React.Component {
    static displayName = 'Select';

    static propTypes = {
        type: PropTypes.string,
        id: PropTypes.string,
        placeholder: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
        error: PropTypes.bool,
        options: PropTypes.array,
        onChange: PropTypes.func,
        onLoad: PropTypes.func,
        onClick: PropTypes.func,
        isCustomDesign: PropTypes.bool,
        className: PropTypes.string,
        locale: PropTypes.string,
        dir: PropTypes.string,
        ariaDescribedBy: PropTypes.string,
        onOpen: PropTypes.func,
        isMobile: PropTypes.bool
    };

    static defaultProps = {
        className: '',
        onOpen: () => {}
    };

    render() {
        const { id, placeholder, value, error, className, options, onChange, onLoad, isCustomDesign,
            locale, dir, onClick, ariaDescribedBy, onOpen, isMobile, type } = this.props;
        const { fieldFillParam, fieldFontParam, fieldTxtParam, fieldBorderParam } = this._getFormStyleParams();

        return (
            <Select key={id}
                    id={id}
                    ref={el => this.select = el}
                    ariaDescribedBy={ariaDescribedBy}
                    placeholder={placeholder}
                    onChange={onChange}
                    onLoad={onLoad}
                    onClick={onClick}
                    onOpen={onOpen}
                    value={value}
                    options={options}
                    closeOthers={true}
                    className={`${className} ${styles.wrapper} ${isCustomDesign ? styles.custom : ''}`}
                    error={error}
                    rtl={dir === 'rtl'}
                    tabIndex={0}
                    dataHook={`reservation_${type === 'time' ? 'time' : 'party_size'}`}
                    isMobile={isMobile}
                    ipadAsMobile={true}
                    isHebrew={locale === 'he_IL'}
                    wix-param-field-fill={fieldFillParam}
                    wix-param-field-font={fieldFontParam}
                    wix-param-field-color={fieldTxtParam}
                    wix-param-field-border-width={fieldBorderParam}/>
        );
    }

    focus = () => {
        if (this.select) {
            this.select.focus();
        }
    };

    _getFormStyleParams = () => {
        const { isCustomDesign } = this.props;
        return {
            fieldFillParam: `${FIELD_FILL_PARAM}${isCustomDesign ? '-custom' : ''}`,
            fieldFontParam: `${FIELD_FONT_PARAM}${isCustomDesign ? '-custom' : ''}`,
            fieldTxtParam: `${FIELD_TEXT_PARAM}${isCustomDesign ? '-custom' : ''}`,
            fieldBorderParam: `${FIELD_BORDER_SIZE_PARAM}${isCustomDesign ? '-custom' : ''}`
        };
    };
}
